/* SORAMI brand layer — one grouped reveal, nothing else global. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function showAll() {
    document.querySelectorAll('.sorami-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  function init() {
    if (reduce.matches || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      // Threshold 0 so tall sections reveal as soon as their top edge enters,
      // rather than waiting for a fixed proportion that a long grid never hits
      // on a short viewport.
      { threshold: 0, rootMargin: '0px 0px -6% 0px' }
    );
    document.querySelectorAll('.sorami-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Anything still hidden after load is a safety net, not a design decision.
  window.addEventListener('load', function () {
    window.setTimeout(function () {
      document.querySelectorAll('.sorami-reveal:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 400);
  });

  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
